// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"5414fc52fb91d1eded00","339":"079106c39c4e7b9aa976"}[chunkId] + ".js";
};